<template>
  <div :class="['wifi-status-container', {offline: !isOnline}]">
    <div class="overlay"></div>
    <v-fade-transition>
      <v-row justify="center" align="center" v-show="!isOnline">
        <v-col cols="12" class="text-center pa-4" >
          <v-alert dark style="max-width: 500px" class="mx-auto my-auto" align="left" :value="true" color="error" icon="mdi-wifi-off">
            Tienes problemas de conexión
            <br>
            <small>Este cuadro se cerrará en cuanto vuelva internet</small>
          </v-alert>
        </v-col>
      </v-row>
    </v-fade-transition>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
  name: "OnlineWatcher",
  props:{
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    ...mapState(['isOnline'])
  },
  created(){
    const vm = this
    vm.setIsOnline(window.navigator.onLine)
    if(!window.navigator.onLine){
      vm.blurWrapper(true)
    }

    window.addEventListener('offline', (e) => {
      vm.setIsOnline(false)
      vm.blurWrapper(true)
    })

    window.addEventListener('online', (e) => {
      vm.setIsOnline(true)
      vm.blurWrapper(false)
    })
  },
  methods: {
    ...mapMutations(['setIsOnline', 'blurWrapper'])
  },
  watch:{}
}
</script>

<style scoped>
  .wifi-status-container{
    color: #fff;
    font-family: 'Roboto', sans-serif;
    z-index: 999;
    position: fixed;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: flex;
    pointer-events: none;
    align-content: center;
    justify-content: center;
  }

  .overlay{
    position: fixed;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    pointer-events: none;
    transition: all .3s;
    background-color: var(--v-background-base);
  }

  .wifi-status-container.offline .overlay{
    pointer-events: auto;
    opacity: .6;
  }

  >>>.v-icon.mdi.mdi-wifi-off.theme--light.v-alert__icon{
    color: #fff
  }

</style>
